import { fromEvent, map, throttleTime } from 'rxjs';

export function addViewportMatcher(creative) {
  creative.platform ??= creative.id.split('_')[0];
  creative.viewportMatcher ??= {};

  const isLanscapeCreative = creative.originalSize.width > creative.originalSize.height;

  switch (true) {
    case creative.platform === 'mobile' && isLanscapeCreative: {
      creative.viewportMatcher.query ??= [
        'screen and (orientation: landscape) and (min-height: 320px) and (min-width: 568px)',
        'screen and (orientation: portrait) and (min-width: 568px)'
      ].join(',');
      break;
    }
    case creative.platform === 'mobile' && !isLanscapeCreative: {
      creative.viewportMatcher.query ??= [
        'screen and (orientation: portrait) and (min-height: 568px) and (min-width: 320px)',
        /* 1.75 is it slightly less than 16/9 (1.77777), greater than 16/10,
         and, more importance, it is greater than 1138/711 (1,600562588) */
        'screen and (orientation: landscape) and (min-width: 568px) and (max-aspect-ratio: 1.75)',
      ].join(',');
      break;
    }
    case creative.platform === 'web': {
      creative.viewportMatcher.query ??= [
        'screen and (orientation: landscape) and (min-height: 320px) and (min-width: 568px)',
        'screen and (orientation: portrait) and (min-width: 568px)'
      ].join(',');
      break;
    }
    case creative.platform === 'tv': {
      creative.viewportMatcher.query ??= 'screen';
      break;
    }
    default: {
      throw new Error('Unknown viewport conditions');
    }
  }

  const matcher = window.matchMedia(creative.viewportMatcher.query);

  let subscription;

  creative.viewportMatcher = {
    get isMatched() {
      return matcher.matches;
    },
    set onchange(fn) {
      if (typeof fn !== 'function') {
        throw new Error('onchange should be a function');
      }
      subscription = fromEvent(matcher, 'change')
        .pipe(
          /* both, site and android apply unexpected transition to our view,
           * but in very own ways.
           * Android webview, and only on landscape to portrait rotate, make:
           * - rotate and applied real size, that does not match constraint;
           * - then resize webview almost to square shape, that match constraint;
           * - then transition them into actual size that does not match constraint
           * An site, instead, on rotate from portrait to landscape, apply incorrect height,
           * based on height in portrait and fix that after 100ms. */
          throttleTime(333),
          map((event) => event.matches)
        )
        .subscribe((matches) => {
          fn(matches);
          return subscription.unsubscribe();
        });
    },
    dispose() {
      subscription?.unsubscribe();
    }
  };
  return creative;
}
